module.exports = __webpack_public_path__ + "static/media/Group.908186b5.svg";